module.exports = __webpack_public_path__ + "img/ics_o_download_pdf_struk.e237817b.svg";